/**
 * @generated SignedSource<<d9a5f77417fe834b118963623ddab729>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DescoperTaskStatus = "FAILURE" | "NOT_FOUND" | "PENDING" | "RUNNING" | "SUCCESS" | "%future added value";
export type StartDescoperTaskInput = {
  brandId: string;
  pageUrl?: string | null;
};
export type InternBrandOnboardingStartTaskMutation$variables = {
  input: StartDescoperTaskInput;
};
export type InternBrandOnboardingStartTaskMutation$data = {
  readonly startDescoperTask: {
    readonly message: string;
    readonly status: DescoperTaskStatus;
    readonly taskKey: string;
  };
};
export type InternBrandOnboardingStartTaskMutation = {
  response: InternBrandOnboardingStartTaskMutation$data;
  variables: InternBrandOnboardingStartTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StartDescoperTaskResponse",
    "kind": "LinkedField",
    "name": "startDescoperTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternBrandOnboardingStartTaskMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternBrandOnboardingStartTaskMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4bf2deaf7f27c9063301a8dbdf4f955a",
    "id": null,
    "metadata": {},
    "name": "InternBrandOnboardingStartTaskMutation",
    "operationKind": "mutation",
    "text": "mutation InternBrandOnboardingStartTaskMutation(\n  $input: StartDescoperTaskInput!\n) {\n  startDescoperTask(input: $input) {\n    taskKey\n    status\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "63ad9f2abd40c36d1678c654815ed8b8";

export default node;
